var render, staticRenderFns
import script from "./comForm.js?vue&type=script&lang=js&"
export * from "./comForm.js?vue&type=script&lang=js&"
import style0 from "./comForm.scss?vue&type=style&index=0&id=7fdb1c1e&scoped=true&lang=scss&"
import style1 from "./comForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb1c1e",
  null
  
)

export default component.exports